
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersDayColour as ObiLightningSnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-day-colour.js';
 
 
 

 
 export const ObiLightningSnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-day-colour',
   elementClass: ObiLightningSnowShowersDayColourElement,
   events: {
     
   }
  });
 
 